<div class="viz-filter-config-modal">
  <div class="filter-modal-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mode-dialog-header>
      <h1 heading>Filter</h1>
      <div sub-heading class="sub-header">
        <span class="sub-header-field">Field:</span>{{ filterField.displayName }}
      </div>
    </mode-dialog-header>
  </div>
  <div class="content-container">
    <ng-container
      *ngIf="(filterStep$ | async) === FilterStepEnum.SelectType; then chooseFilterType; else configureFilter"
    ></ng-container>
  </div>
</div>
<ng-template #chooseFilterType>
  <mode-filter-type-selector
    [field]="formula"
    (canceled)="cancel()"
    (next)="setFilterType($event)"
  ></mode-filter-type-selector>
</ng-template>
<ng-template #configureFilter>
  <mode-filter-configuration
    [field]="filterField"
    [initialFilter]="initialFilter"
    [view]="view"
    [encoding]="encoding"
    [step]="filterStep$ | async"
    [queryRunToken]="queryRunToken"
    (canceled)="cancel()"
    (applyFilter)="applyFilter($event)"
    (fieldChanged)="updateFilterField($event)"
  ></mode-filter-configuration>
</ng-template>
